import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { MdCancel } from "react-icons/md";

const GooglePlaceFilter = ({
  onAddressChange,
  inputStyle = {},
  placeholder = "Search city...",
  apiKey = process.env.REACT_APP_GOOGLE_API_KEY,
  countryRestrictions = [],
}) => {
  const inputRef = useRef(null);
  const [scriptLoaded, setScriptLoaded] = useState(false);
  const autocompleteRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    if (!inputValue) {
      onAddressChange({
        city: "",
        state: "",
        country: "",
        formattedAddress: "",
      });
    }
  }, [inputValue, onAddressChange]);

  useEffect(() => {
    if (window.google?.maps?.places) {
      setScriptLoaded(true);
      return;
    }

    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
    script.async = true;
    script.onload = () => setScriptLoaded(true);
    script.onerror = () => {
      setError("Failed to load Google Maps API");
      console.error("Google Maps script failed to load");
    };

    document.head.appendChild(script);

    return () => {
      if (script.parentNode) {
        document.head.removeChild(script);
      }
    };
  }, [apiKey]);

  useEffect(() => {
    if (!scriptLoaded || !inputRef.current) return;

    const options = {
      types: ["(regions)"],
      fields: ["address_components", "formatted_address", "name"],
    };

    if (countryRestrictions.length > 0) {
      options.componentRestrictions = { country: countryRestrictions };
    }

    autocompleteRef.current = new window.google.maps.places.Autocomplete(
      inputRef.current,
      options
    );

    const handlePlaceChange = () => {
      setLoading(true);
      setError(null);

      const place = autocompleteRef.current.getPlace();

      if (!place?.address_components) {
        setLoading(false);
        return;
      }

      const addressComponents = {};
      place.address_components.forEach((component) => {
        component.types.forEach((type) => {
          addressComponents[type] = component.long_name;
        });
      });

      const city =
        addressComponents.locality ||
        addressComponents.administrative_area_level_2 ||
        addressComponents.postal_town ||
        "";
      const state = addressComponents.administrative_area_level_1 || "";
      const country = addressComponents.country || "";

      const formattedAddress = [city, state, country]
        .filter(Boolean)
        .join(", ");

      setInputValue(formattedAddress);
      onAddressChange({ city, state, country, formattedAddress });
      setLoading(false);
    };

    autocompleteRef.current.addListener("place_changed", handlePlaceChange);

    return () => {
      if (autocompleteRef.current) {
        window.google.maps.event.clearInstanceListeners(
          autocompleteRef.current
        );
      }
    };
  }, [scriptLoaded, countryRestrictions, onAddressChange]);

  // useEffect(() => {
  //   if (!scriptLoaded || !inputRef.current) return;

  //   const options = {
  //     types: ["(regions)"],
  //     fields: ["address_components", "formatted_address", "name"],
  //   };

  //   if (countryRestrictions.length > 0) {
  //     options.componentRestrictions = { country: countryRestrictions };
  //   }

  //   autocompleteRef.current = new window.google.maps.places.Autocomplete(
  //     inputRef.current,
  //     options
  //   );

  //   const handlePlaceChange = () => {
  //     setLoading(true);
  //     setError(null);

  //     const place = autocompleteRef.current.getPlace();

  //     if (!place?.address_components) {
  //       setLoading(false);
  //       return;
  //     }

  //     const addressComponents = {};
  //     place.address_components.forEach((component) => {
  //       component.types.forEach((type) => {
  //         addressComponents[type] = component.long_name;
  //       });
  //     });

  //     const cityData = {
  //       // city: addressComponents.locality ||
  //       //       addressComponents.administrative_area_level_2 ||
  //       //       addressComponents.postal_town ||
  //       //       place.name,
  //       city:
  //         addressComponents.locality ||
  //         addressComponents.administrative_area_level_2 ||
  //         "",
  //       state: addressComponents.administrative_area_level_1,
  //       country: addressComponents.country,
  //       formattedAddress: place.formatted_address,
  //     };

  //     setInputValue(cityData.city);
  //     onAddressChange(cityData);
  //     setLoading(false);
  //   };

  //   autocompleteRef.current.addListener("place_changed", handlePlaceChange);

  //   return () => {
  //     if (autocompleteRef.current) {
  //       window.google.maps.event.clearInstanceListeners(
  //         autocompleteRef.current
  //       );
  //     }
  //   };
  // }, [scriptLoaded, countryRestrictions, onAddressChange]);

  //   const handleClear = () => {
  //     setInputValue("");
  //     if (inputRef.current) {
  //       inputRef.current.value = "";
  //     }
  //     onAddressChange({
  //       city: "",
  //       state: "",
  //       country: "",
  //       formattedAddress: "",
  //     });
  //   };

  const handleClear = () => {
    setInputValue("");
    if (inputRef.current) {
      inputRef.current.value = "";
    }
  };
  return (
    <div
      className="anvCustom_floatInput form-floating address-autocomplete"
      style={{ position: "relative" }}
    >
      <input
        className="form-control"
        ref={inputRef}
        placeholder={placeholder}
        style={{ ...inputStyle, paddingRight: "30px" }}
        disabled={loading}
        required
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
      />
      <label htmlFor="floatingInput">
        <span>{placeholder}</span>
      </label>

      {inputValue && (
        <button
          type="button"
          onClick={handleClear}
          style={{
            position: "absolute",
            right: "10px",
            top: "50%",
            transform: "translateY(-50%)",
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: 0,
            color: "#666",
            zIndex: 99,
          }}
        >
          <MdCancel size={20} />
        </button>
      )}

      {loading && <div className="loading-indicator">Loading details...</div>}
      {error && (
        <div className="error-message" style={{ color: "#ff4444" }}>
          {error}
        </div>
      )}
    </div>
  );
};

GooglePlaceFilter.propTypes = {
  onAddressChange: PropTypes.func.isRequired,
  inputStyle: PropTypes.object,
  placeholder: PropTypes.string,
  apiKey: PropTypes.string,
  countryRestrictions: PropTypes.arrayOf(PropTypes.string),
};

GooglePlaceFilter.defaultProps = {
  inputStyle: {},
  placeholder: "Search city...",
  countryRestrictions: [],
};

export default GooglePlaceFilter;
